export default __webpack_public_path__ + "static/media/resava-problemi.7edebd37.gif";